import { Note } from "pages/Discrepancies/ViewDiscrepancy";
import { AuthService } from "services/Auth";
import { DiscrepData, MsagChangeResponse } from "services/DiscrepancyType";
import { AliErrorRecord } from "./ALIErrorRecord";
import { AliRecord, ALIRecordRequest } from "./ALIRecord";
import APIBaseService from "./APIBase";
import { Criteria, HTTP_METHOD, Response, UserRequest } from "./APIBase.d";
import { AliChange, Discrepancy } from "./DiscrepancyType";
import { Msag } from "./MSAGRecord";
import UserService from "./User";

class RecordService extends APIBaseService {
  authClient = new AuthService();
  userService = new UserService();
  endpoint;
  constructor(endpoint: string) {
    super();
    this.endpoint = endpoint;
  }

  getRecords = async (
    request: UserRequest,
    path: string,
    showCompleted: boolean = false,
    full: boolean = true,
  ): Promise<any> => {
    const user = this.userService.getUser();
    let body = {
      ...request,
      username: user.username,
      ShowCompleted: showCompleted,
      groupID: Number(user.groupID),
      full: full,
    };
    // console.log(body);
    try {
      const res = await this.call(path, HTTP_METHOD.POST, body);
      if (res !== undefined) {
        return res;
      } else {
        console.log("error");
      }
    } catch (error: any) {
      throw new Error(error.message);
    }
  };

  addAliRecord = async (record: AliRecord, path: string) => {
    const user = this.userService.getUser();
    const req = await this.call(path, HTTP_METHOD.POST, {
      Ali: record,
      username: user.username,
      groupID: Number(user.groupID),
    });
    console.log(req);
    return req;
  };

  updateAliRecord = async (cpn: string, record: any, path: string) => {
    const user = this.userService.getUser();
    const criterias = Object.keys(record).map((key) => ({
      field: key,
      value: record[key],
    }));
    const req = await this.call(path, HTTP_METHOD.PUT, {
      Ali: {
        CPN: cpn,
        Criteria: criterias,
      },
      username: user.username,
      groupID: Number(user.groupID),
    });
    console.log(req);
    return req;
  };

  migrateCPN = async (
    cpn: string,
    cpf: string,
    path: string,
    record?: ALIRecordRequest,
  ) => {
    const user = this.userService.getUser();
    let body = {
      cpn: cpn,
      cpf: cpf,
      ALI: {
        ...record,
      },
      username: user.username,
      groupID: Number(user.groupID),
    };

    const req = await this.call(path, HTTP_METHOD.PUT, body);
    console.log(req);
    return req;
  };

  deleteAliRecord = async (record: AliRecord) => {
    const user = this.userService.getUser();
    const request = {
      CPN: record.CPN,
      Criteria: [
        {
          field: "FOC",
          value: "D",
        },
      ],
    };

    const req = await this.call("update", HTTP_METHOD.PUT, {
      Ali: request,
      username: user.username,
      groupID: Number(user.groupID),
    });
    console.log(req);
    return req;
  };

  updateMsagRecord = async (record: Msag, path: string) => {
    const user = this.userService.getUser();

    const req = await this.call(path, HTTP_METHOD.PUT, {
      Ali: record,
      username: user.username,
      groupID: Number(user.groupID),
    });
    console.log(req);
    return req;
  };

  getDiscrepancyData = async (
    discrepancy: Discrepancy,
  ): Promise<DiscrepData> => {
    const user = this.userService.getUser();
    try {
      const data = await this.call("data", HTTP_METHOD.POST, {
        discrepancy: discrepancy,
        username: user.username,
        groupID: Number(user.groupID),
      });
      return data.data.message;
    } catch (error: any) {
      throw new Error(error.message);
    }
  };

  insertChangeRequestDiscrepancy = async (
    discrepancy: AliRecord,
    aliChange: AliChange,
    notes?: {
      note: string;
      submitted_by: string;
    },
  ) => {
    const user = this.userService.getUser();

    const discrepancyData = {
      CBN: discrepancy.CPN,
      ANI: discrepancy.CPN,
      dtype: "ChangeRequest",
      status: "New",
      question: 0,
      submitted_by: user.username,
      table_name: "ali_change_req",
    };

    const req = await this.call("insert", HTTP_METHOD.POST, {
      discrepancy: discrepancyData,
      aliChange: aliChange,
      notes: notes?.note ? notes : undefined,
      username: user.username,
      groupID: Number(user.groupID),
    });

    console.log(req);
    return req;
  };

  createBulkChangeRequest = async (
    criteria: Criteria[],
    aliChange: AliChange,
  ) => {
    const user = this.userService.getUser();

    const note = aliChange.NOTES;
    delete aliChange.NOTES;

    const discrepancyData = {
      dtype: "ChangeRequest",
      status: "New",
      question: 0,
      submitted_by: user.username,
      table_name: "ali_change_req",
    };

    let request = {
      discrepancy: discrepancyData,
      aliChange: aliChange,
      criterias: criteria,
      username: user.username,
      groupID: Number(user.groupID),
      bulk: true,
    };

    if (note) {
      request["notes"] = {
        note: note,
        submitted_by: user.username,
      };
    }

    const req = await this.call("insert", HTTP_METHOD.POST, request);

    console.log(req);
    return req;
  };

  getNotes = async (discrepancy: Discrepancy) => {
    const user = this.userService.getUser();
    const req = await this.call("read", HTTP_METHOD.POST, {
      discrepancy: discrepancy,
      username: user.username,
      groupID: Number(user.groupID),
    });
    return req;
  };

  addNotes = async (
    discrepancy: Discrepancy,
    note: string,
  ): Promise<Note | undefined> => {
    const user = this.userService.getUser();
    const req = await this.call("insert", HTTP_METHOD.POST, {
      discrepancy: discrepancy,
      Note: note,
      username: user.username,
      groupID: Number(user.groupID),
    });
    const newNote = req.data.message;
    return newNote;
  };

  updateDiscrepancy = async (
    type: string,
    discrepancy: Partial<Discrepancy>,
    tableUpdate?: any,
    question?: number,
  ): Promise<Response<Discrepancy>> => {
    const user = this.userService.getUser();
    let payload: any = {
      username: user.username,
      groupID: Number(user.groupID),
      discrepancy: discrepancy,
    };

    if (question !== undefined) payload.question = question;

    if (tableUpdate) {
      if (type === "aliChange") payload.aliChange = tableUpdate;
      else if (type === "discrepancyLvf") payload.discrepancyLvf = tableUpdate;
      else if (type === "msagChangeReq") payload.msagChangeReq = tableUpdate;
      else if (type === "discrepancyAliError")
        payload.discrepancyAliError = tableUpdate;
      else if (type === "discrepancyAliErrorSystemGenerated")
        payload.discrepancyAliErrorSystemGenerated = tableUpdate;
    }

    const req = await this.call("update", HTTP_METHOD.PUT, payload);
    return req.data;
  };

  // deprecated
  updateDiscrepancyQuestion = async (
    id: number,
    question: number,
  ): Promise<Response<Discrepancy>> => {
    const user = this.userService.getUser();
    const req = await this.call("update/question", HTTP_METHOD.PUT, {
      id: id,
      question: question,
      username: user.username,
      groupID: Number(user.groupID),
    });
    return req.data;
  };

  // deprecated
  updateDiscrepancyStatus = async (
    id: number,
    status: string,
  ): Promise<Response<Discrepancy>> => {
    const user = this.userService.getUser();
    const req = await this.call("update/status", HTTP_METHOD.PUT, {
      id: id,
      status: status,
      username: user.username,
      groupID: Number(user.groupID),
    });
    return req.data;
  };

  getMsagChangeReq = async (
    id: number,
  ): Promise<Response<MsagChangeResponse>> => {
    const user = this.userService.getUser();
    const req = await this.call(
      `read/${user.username}/${user.groupID}/${id}`,
      HTTP_METHOD.GET,
      null,
    );

    return req.data.message.msag_change;
  };

  getAutocompleteOptions = async (msagAutocompleteReq): Promise<any> => {
    const user = this.userService.getUser();
    const req = await this.call(`autoComplete`, HTTP_METHOD.POST, {
      msagAutocompleteReq,
      username: user.username,
      groupID: Number(user.groupID),
    });
    return req.data.message;
  };

  exportRecords = async (
    format: string,
    fields: string[] | Record<string, any>,
    criterias: Criteria[],
    showCompleted: boolean = false,
    questionOnly: boolean = false,
    dateRange?: { start: string | null; end: string | null },
  ) => {
    const user = this.userService.getUser();
    const isArray = Array.isArray(fields);
    let exportHeaders = fields;
    if (
      !isArray &&
      format === "v2.1" &&
      typeof fields === "object" &&
      fields.v21header !== undefined
    ) {
      const { v21header, ...rest } = fields;
      exportHeaders = rest;
    }

    const request = {
      Username: user.username,
      GroupID: user.groupID,
      Criterias: criterias,
      Format: format,
      Columns: format === "csv" && isArray ? fields : undefined,
      export_headers: format === "v2.1" && !isArray ? exportHeaders : undefined,
      v21header: format === "v2.1" && !isArray ? fields.v21header : undefined,
    };

    if (showCompleted) request["showCompleted"] = true;
    if (questionOnly) {
      request.Criterias.push({ field: "question", type: "=", value: "1" });
    }
    if (dateRange && dateRange.start && dateRange.end) {
      request.Criterias.push({
        field: "occurred",
        type: "BETWEEN",
        value: `${dateRange.start} 00:00:00,${dateRange.end} 23:59:59`,
      });
    }

    let path;
    if (this.endpoint === "ali") path = "exportRecords";
    else if (this.endpoint === "msag" || this.endpoint === "elt")
      path = "exportByCriteria";
    else if (this.endpoint === "ali/error" || this.endpoint === "discrep")
      path = "export";

    const req = await this.call(path, HTTP_METHOD.POST, request);
    return req;
  };

  exportStatisticalReport = async (
    format: string,
    { startDate, endDate }: { startDate: string; endDate: string },
  ) => {
    const user = this.userService.getUser();
    const request = {
      Username: user.username,
      GroupID: user.groupID,
      format: format,
      columns: [
        "sop_id",
        "CPF",
        "dtype",
        "AveDays",
        "MinDays",
        "MaxDays",
        "DiscrepCount",
        "UnresolvedCount",
        "state",
      ],
      discrepStats: {
        sop_id: user.sopID,
        state: "VT",
        start_date: startDate,
        end_date: endDate,
      },
    };

    const req = await this.call(
      "stats",
      HTTP_METHOD.POST,
      request,
      undefined,
      format === "xlsx"
        ? {
            responseType: "arraybuffer",
          }
        : undefined,
    );

    return req;
  };

  getErrorDescriptionByErrorNumber = async (
    errNumber: number,
  ): Promise<any> => {
    if (!errNumber) return null;
    if (this.endpoint !== "ali/error") return null;

    const user = this.userService.getUser();
    const req = await this.call(
      `stopActions/${user.username}/${user.groupID}`,
      HTTP_METHOD.GET,
      null,
    );

    if (req.data && req.data.message) {
      const stopActions = req.data.message.list;
      return (
        stopActions.find((action) => action.errno === errNumber).error || null
      );
    }

    return null;
  };

  updateAliRErrorRecord = async (record: AliErrorRecord) => {
    const user = this.userService.getUser();
    const aliErrorReq = JSON.stringify(record);

    const req = await this.call("update", HTTP_METHOD.POST, {
      ali_error: aliErrorReq,
      id: record.idx,
      username: user.username,
      groupID: Number(user.groupID),
    });
    console.log(req);
    return req;
  };

  deleteAliErrorRecord = async (idx) => {
    const user = this.userService.getUser();

    const req = await this.call("delete", HTTP_METHOD.POST, {
      Username: user.username,
      GroupID: Number(user.groupID),
      ID: idx,
    });
    console.log(req);
    return req;
  };
}

export default RecordService;
